const serviceApi = () => {
  const getBaseApiUrl = () => {
    const protocol = `${window.location.protocol}`;
    const host =
      `${window.location.host}` === "local.amploadvance.com:3003" && protocol === "http:"
        ? "localhost:3003"
        : `${window.location.host}`;

    return `${protocol}//${host}`;
  };

  const mapPostRequestParams = (token, params) => {
    return {
      headers: getHeadersParams(token),
      method: "POST",
      data: JSON.stringify(params),
    };
  };

  const getHeadersParams = (token) => {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": token,
    };
  };

  return { getBaseApiUrl, mapPostRequestParams };
};

export default serviceApi;
